const NS = 'ServicesOverLap';

export default  function ServicesOverLap() {
  "ngInject";

  return {
    require: 'ngModel',
    link: link,
    restrict: 'A',
    scope: {
      services: '=',
      index: '=',
      startTime: '='
    }
  };

  function link($scope, element, attrs, ngModel) {

    var reCheckInterval;

    var validate = function (viewValue) {
      var services = $scope.services;
      var index = $scope.index;
      if (!ngModel.$modelValue || !ngModel.$viewValue || !services) {
        // It's valid because we have nothing to compare against
        ngModel.$setValidity('services-over-lap', true);
      } else {
        var compareService = services[index];
        var serviceStartTime, serviceEndTime;

        if (compareService && compareService.startTime && compareService.endTime) {
          serviceStartTime = new Date(compareService.startTime.getTime());
          serviceEndTime = new Date(compareService.endTime.getTime());
          if ($scope.startTime) {
            if (ngModel.$viewValue instanceof Date) {
              serviceStartTime.setHours(Number(ngModel.$viewValue.getHours()));
              serviceStartTime.setMinutes(Number(ngModel.$viewValue.getMinutes()));
            } else {
              serviceStartTime.setHours(Number(ngModel.$viewValue.split(':')[0]));
              serviceStartTime.setMinutes(Number(ngModel.$viewValue.split(':')[1]));
            }

          } else {
            if (ngModel.$viewValue instanceof Date) {
              serviceEndTime.setHours(Number(ngModel.$viewValue.getHours()));
              serviceEndTime.setMinutes(Number(ngModel.$viewValue.getMinutes()));
            } else {
              serviceEndTime.setHours(Number(ngModel.$viewValue.split(':')[0]));
              serviceEndTime.setMinutes(Number(ngModel.$viewValue.split(':')[1]));
            }
          }
        }

        var valid = true;
        var timeout = 1500;
        for (var i = services.length - 1; i >= 0; i--) {
          var service = services[i];
          if (service._id !== compareService._id) {
            var conflict = true;

            var startTime = new Date(service.startTime);
            var endTime = new Date(service.endTime);


            if (serviceStartTime.getTime() <= startTime.getTime() && serviceEndTime.getTime() <= startTime.getTime()) {
              // the service is compeletly before the the service
              conflict = false;
            }
            if (serviceStartTime.getTime() >= endTime.getTime() && serviceEndTime.getTime() >= endTime.getTime()) {
              // the service is compeletly after the the service
              conflict = false;
            }

            if (conflict) {
              valid = false;
              timeout = 500;
              break;
            }
          }
        }

        clearInterval(reCheckInterval);
        reCheckInterval = setTimeout(function () {
          validate(ngModel.$viewValue);
        }, timeout);

        ngModel.$setValidity('services-over-lap', valid);
      }
      return viewValue;
    };

    function destory() {
      clearInterval(reCheckInterval);
    }

    ngModel.$parsers.unshift(validate);
    ngModel.$formatters.push(validate);

    $scope.$watch('services', function () {
      validate(ngModel.$viewValue);
    });

    $scope.$on('$destroy', destory);

    attrs.$observe('servicesOverLap', function () {
      // Whenever the comparison model changes we'll re-validate
      return validate(ngModel.$viewValue);
    });
  }
}
